import { Dropdown, VerticalContainer } from '@american-autonomy/ag-ui';

import LabelText from 'components/text/LabelText';

import { PRODUCT_CATEGORY_OPTIONS } from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/SpraySettingsSection/constants';

import { DROPDOWN_TEST_ID, NOT_FOUND_INDEX, TEST_ID } from './constants';
import type {
    ApplicationSettingsCreateRequestProductCategory,
    FunctionComponent,
    Props
} from './types';

import styles from './styles.module.scss';

const ProductCategoryField: FunctionComponent<Props> = ({
    className = '',
    label,
    onChange,
    testId = TEST_ID,
    value
}) => {
    const selectedIndex = PRODUCT_CATEGORY_OPTIONS.findIndex(option => option.value === value);
    const safeIndex = selectedIndex === NOT_FOUND_INDEX ? 0 : selectedIndex;

    const handleChange = (nextValue: string) => {
        onChange({
            productCategory: nextValue as ApplicationSettingsCreateRequestProductCategory
        });
    };

    return (
        <VerticalContainer
            className={`${className} ${styles.productCategoryField}`}
            testId={testId}>
            <LabelText text={label} />

            <Dropdown
                items={PRODUCT_CATEGORY_OPTIONS}
                onChange={handleChange}
                selected={safeIndex}
                testId={DROPDOWN_TEST_ID}
            />
        </VerticalContainer>
    );
};

export default ProductCategoryField;
